import React from 'react';
import NeuralNetworkBg from '../../../components/feature/NeuralNetworkBg';

export default function CTASection() {
  return (
    <section id="cta" className="relative py-28 lg:py-40 px-6 lg:px-12 overflow-hidden">
      {/* Softer animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-orange/90 via-brand-pink/90 to-brand-violet/90 animate-gradient-shift-slow"></div>

      {/* Overlay for depth */}
      <div className="absolute inset-0 bg-black/15"></div>

      {/* Neural network overlay */}
      <NeuralNetworkBg
        color="255,255,255"
        nodeCount={35}
        opacity={0.12}
        speed={0.5}
        variant="dark"
      />

      {/* Floating orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute w-[600px] h-[600px] rounded-full animate-float opacity-15"
          style={{
            background:
              'radial-gradient(circle, rgba(255,255,255,0.25) 0%, transparent 70%)',
            top: '-20%',
            right: '-10%',
          }}
        ></div>
        <div
          className="absolute w-[400px] h-[400px] rounded-full animate-float-slow opacity-10"
          style={{
            background:
              'radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)',
            bottom: '-10%',
            left: '10%',
            animationDelay: '2s',
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <img
          src="https://public.readdy.ai/ai/img_res/d5f7e579-8018-4b49-b964-96ae4bfad480.png"
          alt="Brain Wash"
          className="h-20 w-auto mx-auto mb-10 drop-shadow-2xl animate-float-slow"
        />

        <h2 className="text-5xl lg:text-7xl font-bold text-white mb-6 tracking-tight leading-tight">
          Change your baseline.
        </h2>

        <p className="text-lg text-white/60 max-w-xl mx-auto mb-12">
          Your brain is waiting to be reconditioned. Join the reset and reclaim what&apos;s yours.
        </p>

        {/* Embedded Brevo Signup Form */}
        <div className="max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-2xl shadow-black/20">
          <iframe
            src="https://f44bc325.sibforms.com/serve/MUIFAIz2L6kNgsrr_JR0es3JlqRtcSkeMAnui5AF5J9-6k5MUoJiOOEO9BFzo96HhYfBUYdNHUMccUaXR28yGsBGCAB4uF6BRjoY6TbdGFLk9zxIDIgIoAg9u0kdchVVcY8LCJeuUwwuh5_7Mmn8ocoadRFYmk9f5MkrrfiC4qMVPFrgOl4VpmpdAkusfkOcVveo2Hwr9staJGm4Ug=="
            title="Join Wait List"
            className="w-full border-0"
            style={{ height: '520px' }}
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}
